<div class="treeview-container">
  <ng-container *ngIf="searchable">
    <div class="select-wrapper">
      <div class="card-body search-template">
        <input type="search" [formControl]="searchControl" />
        <i class="ti-search"></i>
      </div>
    </div>
  </ng-container>
  <ng-content select="[another-filter]"></ng-content>
  <div class="items-wrapper">
    <div
      slimScroll
      width="auto"
      [height]="scrollHeight"
      size="3px"
      alwaysVisible="true"
      class="media-body business-unit-wrap"
      *ngIf="items"
    >
      <app-treeview-item
        *ngFor="let item of items"
        [getKey]="dataProvider.getKey"
        [getDisplayName]="dataProvider.getDisplayName"
        (onSelect)="select($event)"
        [selectedItem]="selectedItem"
        [item]="item"
        [template]="template"
      ></app-treeview-item>
    </div>
  </div>
</div>
